import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { REPORT_MIN_MATCHES, isReportUnlocked } from "../../helpers/reportGate";
import ActiveBuyerReportComingSoonModal from "./ActiveBuyerReportComingSoonModal";
import { downloadIconTwo } from "@/images";
import {
  downloadBuyerMatchReport,
  buyerMatchReportErrorMessage,
} from "../../services/v2/buyerMatchReport";

export { REPORT_MIN_MATCHES };

const BUTTON_STYLE = {
  marginTop: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 40,
  padding: 0,
  letterSpacing: "unset",
};

const ReportCTA = ({ inventoryId, totalMatches = 0 }) => {
  const [showComingSoon, setShowComingSoon] = useState(false);
  const unlocked = isReportUnlocked(totalMatches);

  // Reset the coming-soon modal when the selected property changes, so it
  // doesn't stay open (referencing the old property) if left open while
  // switching properties.
  useEffect(() => {
    setShowComingSoon(false);
  }, [inventoryId]);

  const openReport = () => {
    if (!inventoryId) return;
    downloadBuyerMatchReport(inventoryId).catch((err) =>
      toast.error(buyerMatchReportErrorMessage(err))
    );
  };

  return (
    <>
      <Button
        className="btn-grey w-100"
        data-tour="download-report-match"
        onClick={unlocked ? openReport : () => setShowComingSoon(true)}
        style={BUTTON_STYLE}
      >
        Download Report
        <img
          src={downloadIconTwo}
          style={{ width: 12, height: 12, marginLeft: 8 }}
          alt=""
        />
      </Button>
      {!unlocked && (
        <ActiveBuyerReportComingSoonModal
          show={showComingSoon}
          onHide={() => setShowComingSoon(false)}
        />
      )}
    </>
  );
};

export default ReportCTA;
